import { Component, Input } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'delete-item-modal',
  templateUrl: './delete-item-modal.component.html',
  styleUrls: ['./delete-item-modal.component.scss'],
  standalone: false,
})
export class DeleteItemModalComponent {
  @Input() title: string = '';
  @Input() item: string = '';
  @Input() warninglabel: string = '';
  @Input() values: string[] = [];

  constructor(public _activeModal: NgbActiveModal) {}

  deleteItemActionHandler(deleteConfirmed: boolean) {
    this._activeModal.close(deleteConfirmed);
  }
}
